export const storefrontBrand = Object.freeze({
  officialName: '반짝서랍',
  tagline: '열어볼 때마다 작은 발견',
  storeTitle: '반짝서랍 | 생활의 작은 불편을 줄이는 도구',
  namingStatus: 'selected_with_constraints' as const
});
